export default "__VITE_ASSET__Bl6Ja_b1__"